
import { RevTag } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import RatingInfo from '@reviews/Internal/components/RatingInfo'

import { SMARTPHONE_CATEGORY_ID } from '../../pages/product.constants'
import productTranslations from '../../pages/product.translations'
import EcoBlockAnchor from '../EcoBlockAnchor'
import Gallery from '../Gallery'
import Model from '../Model'

import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './FixedContainer.constants'
import translations from './FixedContainer.translations'

export default {
  components: {
    EcoBlockAnchor,
    Gallery,
    Model,
    RatingInfo,
    RevTag,
  },

  props: {
    reassurance: {
      type: Object,
      required: true,
    },

    ratings: {
      type: Object,
      required: true,
    },

    images: {
      type: Array,
      required: true,
    },

    page: {
      type: Object,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    modelTitle: {
      type: String,
      required: true,
    },

    modelSubtitles: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,

    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
      experiments: 'experiments/getExperiments',
    }),

    reassuranceTag() {
      return this.$t(productTranslations.warrantyRefund, {
        days: this.coolingOffDays,
      })
    },

    isOutOfStock() {
      return this.page.variations.isOutOfStock
    },

    shouldDisplayReassuranceTag() {
      return !this.isOutOfStock && !this.shouldDisplayEcoBlock
    },

    // TODO: [BRO-1955] clean abtest
    shouldDisplayEcoBlock() {
      return (
        ['reassuranceInfoAbove', 'reassuranceInfoBlockNewWording'].includes(
          this.experiments.ppContentReassuranceInfoPosition,
        ) &&
        this.product.trackingDetails.category3MarketplaceCategory_ID ===
          SMARTPHONE_CATEGORY_ID
      )
    },
  },
}
